import { render, staticRenderFns } from "./HowToConsignmentPage.vue?vue&type=template&id=21b51fd2&scoped=true&"
import script from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"
export * from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b51fd2",
  null
  
)

export default component.exports